import { makeAutoObservable } from 'mobx';
import { defaultTemplateConstant } from '../../components/displays/newTradingInterface/tradingModule/TradingModule';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class SavedTradePlanTemplatesStore {
  root;
  savedTemplates = {};
  savedTemplatesSubject;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.savedTemplatesSubject = groupByFunction(
      'messageType',
      'savedTradePlansConfigurations',
      this.root.websocketSubject
    ).subscribe(this.setTemplates);
  };

  setTemplates = (msg) => {
    const templates = msg.configurations;
    const newTemplates = {};
    templates.forEach((template) => {
      newTemplates[template.configurationName] = {
        configurationName: template.configurationName,
        tradePlanJson: template.json.json,
        key: template.key,
      };
    });
    this.savedTemplates = newTemplates;
  };

  get templatesList() {
    return Object.keys(this.savedTemplates)
      .filter(name => name !== defaultTemplateConstant)
      .sort((a, b) => a.localeCompare(b))
      .map((name) => this.savedTemplates[name]);
  }
}
